<script>
  import { confirmStore } from './confirm.js'
  import Button from './ui/button.svelte'

  let pending = $state(null)

  confirmStore.subscribe((value) => {
    pending = value
  })

  const respond = (result) => {
    pending?.resolve(result)
    confirmStore.set(null)
  }

  const onkeydown = (event) => {
    if (pending && event.key === 'Escape') respond(false)
  }
</script>

<svelte:window {onkeydown} />

<dialog class="modal" class:modal-open={!!pending}>
  <div class="modal-box">
    {#if pending?.title}<h3 class="text-lg font-bold mb-4">{pending.title}</h3>{/if}

    {#if pending?.body}<p class="py-2">{pending.body}</p>{/if}

    <div class="modal-action">
      <Button variant="ghost" onclick={() => respond(false)}>
        {pending?.cancelLabel || 'Cancel'}
      </Button>
      <Button variant={pending?.variant || 'primary'} onclick={() => respond(true)}>
        {pending?.confirmLabel || 'Confirm'}
      </Button>
    </div>
  </div>

  <button type="button" class="modal-backdrop" aria-label="Cancel" onclick={() => respond(false)}></button>
</dialog>
